import { render, staticRenderFns } from "./select_stock.vue?vue&type=template&id=5b63f92d&scoped=true&"
import script from "./select_stock.vue?vue&type=script&lang=js&"
export * from "./select_stock.vue?vue&type=script&lang=js&"
import style0 from "./select_stock.vue?vue&type=style&index=0&id=5b63f92d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b63f92d",
  null
  
)

export default component.exports